import makeService from './api';

export default makeService('ticket_origins');
